import { Prose } from '../../components/Prose'
import type { Profile } from '../../lib/metrics'

export function DeskTab({ profile }: { profile: Profile }) {
  return (
    <>
      <div className="card">
        <h2>Asıl problem: 9 saat oturuyorsun</h2>
        <Prose className="card-h">
          Remote yazılımcının en büyük dezavantajı da avantajı da aynı şey — kimse seni izlemiyor.
          Kalkma alışkanlığını sisteme gömmen gerekiyor, hatırlamana bırakamazsın.
        </Prose>
        <ul className="tight">
          <li><strong>{profile.workMinutes}/{profile.breakMinutes} kuralı.</strong> Mola Sayacı sekmesindeki zamanlayıcıyı aç, gerisini o halleder — irade değil zamanlayıcı işi.</li>
          <li><strong>Molada ne yapılır:</strong> mutfağa git su doldur, 20 squat yap, balkona çık, esne. Oturarak telefon karıştırmak mola değil.</li>
          <li><strong>Toplantı = yürüyüş.</strong> Kamerasız/dinleyici olduğun toplantılarda kulaklık tak ve yürü. Haftada 4–5 toplantı = 2.000–3.000 ekstra adım/gün.</li>
          <li><strong>Ayakta çalışma.</strong> Standing desk varsa günde 2 saat ayakta çalış. Yoksa code review/mail saatini yüksek bir tezgâhta geçir.</li>
          <li><strong>Masada yemek yok.</strong> Öğünleri mutfakta ye. Bu tek değişiklik hem porsiyonu düşürür hem molayı garantiler.</li>
          <li><strong>Masada atıştırmalık bulundurma.</strong> Kutu çerez masada duruyorsa kod tıkandığında elin oraya gider.</li>
          <li><strong>18:00'da bilgisayarı kapat.</strong> Akşam kayması hem yürüyüşü hem yemeği hem uykuyu bozuyor.</li>
        </ul>
      </div>

      <div className="card">
        <h2>Stres ve gece atıştırması</h2>
        <ul className="tight">
          <li><strong>Deploy günü / bug gecesi</strong> yeme isteği gerçek — kortizol iştahı artırır. O akşamlar için hazır bir "güvenli atıştırmalık" bulundur (süzme yoğurt, 20 badem, elma).</li>
          <li><strong>Mutfak {profile.kitchenClose.slice(0, 5)}'te kapanır.</strong> Tenis günleri hariç bu saatten sonra yemek yok — sadece su, sade çay.</li>
          <li><strong>Diş fırçala.</strong> Basit ama işe yarar: fırçalanmış ağızla atıştırmak istemezsin.</li>
          <li><strong>Uyku = iştah kontrolü.</strong> 6 saatin altında ghrelin artar, leptin düşer; ertesi gün 300–500 kcal fazla yersin ve fark etmezsin.</li>
          <li><strong>Açlık mı can sıkıntısı mı?</strong> "Bir tabak salata yer miydim?" diye sor. Cevap hayırsa aç değilsin. Bir bardak su iç, 5 dk yürü, tekrar sor.</li>
        </ul>
      </div>

      <div className="card">
        <h2>Plato geldiğinde</h2>
        <div className="warnbox">
          <strong>2–3 hafta tartı kıpırdamayabilir, bu normaldir.</strong> Bu noktada plana <em>daha sıkı</em> sarılmak
          yerine önce kaydı kontrol et: porsiyonlar gerçekten aynı mı, adım düştü mü, uyku bozuldu mu?
          Genelde cevap oradadır. 4 haftadan uzun süren gerçek platoda kalori hedefini 150–200 kcal düşür.
        </div>
        <Prose className="note" style={{ marginTop: 16 }}>
          Bu panel genel sağlıklı yaşam bilgisi sunar, tıbbi tavsiye değildir. Bilinen bir hastalığın,
          kullandığın ilaç varsa ya da tahlillerinde bir şey çıkarsa planı doktorunla / bir diyetisyenle uyarla.
        </Prose>
      </div>
    </>
  )
}
